export default __webpack_public_path__ + "static/media/upload.9c2dc088.jpeg";